import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

export const SelectionCard = ({
  selected = false,
  onClick,
  icon: Icon,
  title,
  subtitle,
  meta,
  hint,
  className,
  testId,
  index = 0,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testId}
      style={{ animationDelay: `${index * 60}ms` }}
      className={cn(
        "selection-card relative flex flex-col items-start gap-4 p-5 md:p-6 rounded-2xl border text-left w-full h-full overflow-hidden",
        "transition-[transform,background,border,box-shadow] duration-300 ease-out",
        "active:scale-[0.98] focus:outline-none focus:ring-2 focus:ring-zinc-400 dark:focus:ring-white/20",
        selected
          ? "bg-zinc-900 border-zinc-900 text-zinc-50 shadow-[0_8px_40px_rgba(0,0,0,0.12)] dark:bg-zinc-800/90 dark:border-white/30 dark:shadow-[0_8px_40px_rgba(255,255,255,0.06)] -translate-y-0.5"
          : "bg-white/80 border-zinc-200 text-zinc-700 hover:bg-white hover:border-zinc-300 hover:-translate-y-1 hover:shadow-xl dark:bg-zinc-900/40 dark:border-white/[0.06] dark:text-zinc-300 dark:hover:bg-zinc-900/80 dark:hover:border-white/15 dark:hover:shadow-2xl",
        className
      )}
    >
      {/* Selected indicator */}
      <span
        className={cn(
          "absolute top-3 right-3 h-6 w-6 rounded-full flex items-center justify-center border transition-all duration-300",
          selected
            ? "bg-zinc-50 border-zinc-50 text-zinc-900 scale-100 dark:bg-zinc-50 dark:border-zinc-50 dark:text-zinc-950"
            : "bg-transparent border-zinc-300 text-transparent scale-90 dark:border-white/15"
        )}
      >
        <Check className="h-3.5 w-3.5" strokeWidth={3} />
      </span>

      {Icon && (
        <span
          className={cn(
            "h-11 w-11 rounded-xl flex items-center justify-center transition-colors",
            selected
              ? "bg-zinc-50 text-zinc-900 dark:bg-zinc-50 dark:text-zinc-950"
              : "bg-zinc-100 text-zinc-700 dark:bg-zinc-800/70 dark:text-zinc-300"
          )}
        >
          <Icon className="h-5 w-5" strokeWidth={1.75} />
        </span>
      )}

      <div className="flex flex-col gap-1">
        <h3
          className={cn(
            "text-base md:text-lg font-medium tracking-tight leading-tight font-display",
            selected
              ? "text-zinc-50"
              : "text-zinc-900 dark:text-zinc-50"
          )}
        >
          {title}
        </h3>
        {subtitle && (
          <p
            className={cn(
              "text-sm font-medium",
              selected ? "text-zinc-300" : "text-zinc-600 dark:text-zinc-400"
            )}
          >
            {subtitle}
          </p>
        )}
        {hint && (
          <p
            className={cn(
              "text-xs mt-0.5 leading-snug",
              selected ? "text-zinc-400" : "text-zinc-500 dark:text-zinc-500"
            )}
          >
            {hint}
          </p>
        )}
      </div>

      {meta && (
        <div
          className={cn(
            "mt-auto pt-2 text-xs tracking-[0.18em] uppercase font-semibold",
            selected ? "text-zinc-400" : "text-zinc-500 dark:text-zinc-500"
          )}
        >
          {meta}
        </div>
      )}
    </button>
  );
};
